import React from 'react';
import { Col } from 'react-bootstrap';
import { Content, PageTitle } from '.';
import { BreadCrumbTrail } from './nav/BreadCrumbTrail';

interface IMainContentProps {
  cols?: number;
  showBreadcrumbs?: boolean;
  title?: string;
}

export const MainContent = ({
  cols = 10,
  showBreadcrumbs = true,
  ...props
}: React.PropsWithChildren<IMainContentProps>) => (
  <Col md={cols} className="main-column g-0">
    {showBreadcrumbs && <BreadCrumbTrail />}
    <div className="page-content m-3">
      {props.title && <PageTitle text={props.title}></PageTitle>}
      <Content>{props.children}</Content>
    </div>
  </Col>
);
